class Utils {
  static objIsEmpty(obj) {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }

  static loopThroughAnObject(obj) {
    obj[Symbol.iterator] = function() {
      return {
        entries: Object.entries(this),
        i: 0,
        next() {
          if (this.i >= this.entries.length) {
            return { done: true, value: undefined };
          }
          return {
            done: false,
            value: {
              [this.entries[this.i][0]]: this.entries[this.i++][1]
            }
          };
        }
      };
    };
  }

  static generateNineRandomNumbers() {
    return Math.floor(100000000 + Math.random() * 900000000);
  }

  static saveToLocalStorage(key, payload) {
    localStorage.setItem(key, payload);
  }

  static getFromLocalStorage(key) {
    return localStorage.getItem(key);
  }

  static removeFromLocalStorage(key) {
    return localStorage.removeItem(key);
  }

  static clearLocalStorage() {
    localStorage.clear();
  }

  static containsObject(obj, list) {
    return list.some(elem => elem === obj);
  }

  static capitalize(word) {
    return word[0].toUpperCase() + word.slice(1).toLowerCase();
  }

  static splitString = (string, separator, keepEmptyStrings) => {
    if (typeof string === "string" && typeof separator === "string") {
      if (keepEmptyStrings) return string.trim().split(separator);
      else return string.split(separator).filter(word => word.trim() !== "");
    } else return [];
  };

  static capitaliseFirstLetter = string => {
    if (typeof string !== "string" || !string.length) return "";

    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  static getStandardDate = string => {
    if (typeof string !== "string" || !string.length) return new Date();

    const date = new Date(string);
    return new Date(new Date(date).setHours(new Date(date).getHours() + 1));
  };
}
export default Utils;
